// Vite environment variables - accessed via import.meta.env
// All variables must be prefixed with VITE_ in .env files

let REGION = import.meta.env.VITE_REACT_APP_REGION;
//console.log("Build 18/07/2022");

let cognito = {
  REGION: REGION,
  USER_POOL_ID: import.meta.env.VITE_REACT_APP_USER_POOL_ID,
  APP_CLIENT_ID: import.meta.env.VITE_REACT_APP_APP_CLIENT_ID,
  IDENTITY_POOL_ID: import.meta.env.VITE_REACT_APP_POOL_ID,
};

let apiGateway = {
  URL: import.meta.env.VITE_REACT_APP_API_GATEWAY_URL,
  WEB_SOCKET_URL: import.meta.env.VITE_REACT_APP_WEB_SOCKET_URL,
};

let googleMap = {
  API: import.meta.env.VITE_REACT_APP_GOOGLE_MAPS_API_KEY,
};

let stripe = {
  STRIPE_KEY: import.meta.env.VITE_REACT_APP_STRIPE_KEY,
};

let BuildVersion = import.meta.env.VITE_React_APP_Build_Version;

let FeatureFlagAPIKey = import.meta.env.VITE_React_APP_Feature_Flag_API_Key;

const getOwnerPortalUrl = () => {
  if (typeof window === "undefined") return "https://owner.yvooa.com/";

  const { hostname, port } = window.location;
  const isLocalDev =
    (hostname === "localhost" || hostname === "127.0.0.1") &&
    /^300/.test(port);

  if (hostname === "pm-dev.yvooa.com" || isLocalDev) {
    return "https://owner-dev.yvooa.com/";
  }
  if (hostname === "pm-uat.yvooa.com") {
    return "https://owner-uat.yvooa.com/";
  }
  return "https://owner.yvooa.com/";
};

let ownerPortalUrl = getOwnerPortalUrl();

export default {
  cognito,
  apiGateway,
  googleMap,
  stripe,
  BuildVersion,
  FeatureFlagAPIKey,
  ownerPortalUrl,
};
